import React from 'react';
import LoadDetails from '../../LoadSection/LoadDetails/LoadDetails';
import LoadHeader from '../../LoadSection/LoadHeader/LoadHeader';
import LoadStatusOverview from '../../LoadSection/LoadStausOverview/LoadStausOverview';
import POSection from '../../LoadSection/POSection/POSection';
import CommentsSection from '../../Comments/CommentsSection';
import './TruckDetailsSection.css';
import DoorAssignedTimer from '../../LoadSection/DoorAssignment/DoorAssignmentTimer/DoorAssignedTimer';
import DoorAssingment from '../../LoadSection/DoorAssignment/DoorAssignment';
import DoorAssignmentIMSSP from '../../LoadSection/DoorAssignment/DoorAssignmentIMSSP';
import { getFilterViewExpanded } from '../../../../../../redux/reducers/reducerSlices/FiltersReducerSlice';
import { useSelector } from 'react-redux';

const TruckDetailsSection = (props) => {
    const { themeSelected, type } = props;
    const {isFilterViewExpanded}  = useSelector(getFilterViewExpanded);
    return (
        <div className={`pODetailsSection d-flex flex-column ${themeSelected}`}
            style={{maxHeight: isFilterViewExpanded ? '40vh' : '60vh' }}
        >
            <LoadHeader {...props} />
            <LoadDetails {...props} />
            <LoadStatusOverview {...props} />
            <POSection {...props} type={ type} />
            {type === 'IMS' ? <DoorAssingment {...props} />: <DoorAssignmentIMSSP {...props} />}
            <DoorAssignedTimer {...props} />
            <CommentsSection {...props} type={ type } />
        </div>
    )
}
export default TruckDetailsSection;